<!-- Loader con porcentaje (pastel, centrado) -->
<div class="loader-wrapper" *ngIf="loading">
    <div class="loader-card">
        <div class="brand">
            <mat-icon>insights</mat-icon>
            <h3>Estadísticas</h3>
        </div>

        <p class="muted">{{ loadingTip }}</p>

        <!-- Reemplaza <div class="progress-wrap"> ... </div> por esto -->
        <div class="ring-wrap" aria-label="Cargando estadísticas">
            <svg
                class="ring"
                viewBox="0 0 120 120"
                role="img"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="ringGrad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#93c5fd" />
                        <!-- azul claro -->
                        <stop offset="50%" stop-color="#d8b4fe" />
                        <!-- violeta claro -->
                        <stop offset="100%" stop-color="#a7f3d0" />
                        <!-- verde claro -->
                    </linearGradient>
                </defs>

                <!-- Fondo -->
                <circle class="ring-bg" cx="60" cy="60" r="54" />

                <!-- Progreso -->
                <circle
                    class="ring-fg"
                    cx="60"
                    cy="60"
                    r="54"
                    [attr.stroke-dasharray]="339.292"
                    [attr.stroke-dashoffset]="
                        339.292 - (progress / 100) * 339.292
                    "
                    stroke="url(#ringGrad)"
                />
            </svg>

            <div class="ring-center">
                <div class="ring-percent">
                    {{ progress | number : "1.0-0" }}%
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contenido -->
<nav
    *ngIf="!loading"
    class="sb-topnav navbar navbar-expand navbar-light pastel-nav"
>
    <div class="container-fluid">
        <a class="navbar-brand">Estadísticas</a>
        <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link active" routerLink="/">Inicio</a>
                </li>
                <li class="nav-item dropdown">
                    <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        >Opciones</a
                    >
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li>
                            <a class="dropdown-item" routerLink="/">Inicio</a>
                        </li>
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/ofertas-estadisticas"
                                >Ofertas Estadísticas</a
                            >
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li><a class="dropdown-item" href="#">Reportes</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div *ngIf="!loading" class="container-fluid px-4">
    <div *ngIf="!loading" class="container-fluid px-4">
        <div class="toolbar toolbar-sb">
            <div class="toolbar-left">
                <button
                    mat-mini-fab
                    (click)="setDataFormarefreshComponents()"
                    aria-label="Refrescar"
                    class="btn-refresh"
                    matTooltip="Actualizar estadísticas"
                >
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>

            <div
                class="toolbar-right kpi-chips"
                aria-label="Indicadores rápidos"
            >
                <div class="chip" aria-label="Usuarios totales">
                    <mat-icon class="chip-icon">perm_identity</mat-icon>
                    <span class="chip-label">Usuarios</span>
                    <span class="chip-value">{{
                        cantTotalUsuarios | number
                    }}</span>
                </div>

                <div class="chip" aria-label="Solicitudes totales">
                    <mat-icon class="chip-icon">fact_check</mat-icon>
                    <span class="chip-label">Solicitudes</span>
                    <span class="chip-value">{{
                        cantTotalSolicitudes | number
                    }}</span>
                </div>
            </div>
        </div>

        <div class="row g-3">
            <!-- Presentados -->
            <div class="col-xl-3 col-md-6">
                <div class="card metric-card metric-presentados">
                    <div class="card-body">
                        Presentados
                        <span class="badge soft">{{ cantPresentados }}</span>
                    </div>
                </div>
            </div>

            <!-- En Revisión -->
            <div class="col-xl-3 col-md-6">
                <div class="card metric-card metric-revision">
                    <div class="card-body">
                        En Revisión
                        <span class="badge soft">{{ cantEnRevision }}</span>
                    </div>
                </div>
            </div>

            <!-- En Auditoría Médica -->
            <div class="col-xl-3 col-md-6">
                <div class="card metric-card metric-auditoria">
                    <div class="card-body">
                        En Auditoría Médica
                        <span class="badge soft">{{ cantEnAuditoria }}</span>
                    </div>
                </div>
            </div>

            <!-- Aprobadas -->
            <div class="col-xl-3 col-md-6">
                <div class="card metric-card metric-aprobados">
                    <div class="card-body">
                        Aprobadas
                        <span class="badge soft">{{
                            cantEstadoAprobadas
                        }}</span>
                    </div>
                </div>
            </div>

            <!-- Rechazadas -->
            <div class="col-xl-3 col-md-6">
                <div class="card metric-card metric-rechazados">
                    <div class="card-body">
                        Rechazadas
                        <span class="badge soft">{{
                            cantEstadoRechazadas
                        }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Gráficos -->
        <div class="row g-3">
            <div class="col-xl-6">
                <div class="card pastel-card">
                    <div class="card-header">
                        <i class="fas fa-chart-pie me-1"></i> Solicitudes por
                        estado
                    </div>
                    <div class="card-body">
                        <app-doughnut-chart
                            [cantPresentados]="cantPresentados"
                            [cantDocumentosCargados]="cantDocumentosCargados"
                            [cantEnRevision]="cantEnRevision"
                            [cantEnAuditoria]="cantEnAuditoria"
                            [cantEstadoAprobadas]="cantEstadoAprobadas"
                            [cantEstadoRechazadas]="cantEstadoRechazadas"
                        >
                        </app-doughnut-chart>
                    </div>
                </div>
            </div>

            <div class="col-xl-6">
                <div class="card pastel-card">
                    <div class="card-header">
                        <i class="fas fa-chart-bar me-1"></i> Progreso por etapa
                    </div>
                    <div class="card-body">
                        <div class="progress-block">
                            <p class="card-text">Presentados</p>
                            <div class="progress">
                                <div
                                    class="progress-bar pb-presentados"
                                    role="progressbar"
                                    [style.width]="porcPresentados + '%'"
                                    [attr.aria-valuenow]="porcPresentados"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ porcPresentados | number : "1.0-0" }}%
                                </div>
                            </div>
                        </div>

                        <div class="progress-block">
                            <p class="card-text">Documentos Cargados</p>
                            <div class="progress">
                                <div
                                    class="progress-bar pb-docs"
                                    role="progressbar"
                                    [style.width]="porcDocCargados + '%'"
                                    [attr.aria-valuenow]="porcDocCargados"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ porcDocCargados | number : "1.0-0" }}%
                                </div>
                            </div>
                        </div>

                        <div class="progress-block">
                            <p class="card-text">En Revisión</p>
                            <div class="progress">
                                <div
                                    class="progress-bar pb-revision"
                                    role="progressbar"
                                    [style.width]="porcEnRevision + '%'"
                                    [attr.aria-valuenow]="porcEnRevision"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ porcEnRevision | number : "1.0-0" }}%
                                </div>
                            </div>
                        </div>

                        <div class="progress-block">
                            <p class="card-text">En Auditoría Médica</p>
                            <div class="progress">
                                <div
                                    class="progress-bar pb-auditoria"
                                    role="progressbar"
                                    [style.width]="porcEnAuditoria + '%'"
                                    [attr.aria-valuenow]="porcEnAuditoria"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ porcEnAuditoria | number : "1.0-0" }}%
                                </div>
                            </div>
                        </div>

                        <div class="progress-block">
                            <p class="card-text">Aprobados</p>
                            <div class="progress">
                                <div
                                    class="progress-bar pb-aprobados"
                                    role="progressbar"
                                    [style.width]="porcAprobados + '%'"
                                    [attr.aria-valuenow]="porcAprobados"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ porcAprobados | number : "1.0-0" }}%
                                </div>
                            </div>
                        </div>

                        <div class="progress-block">
                            <p class="card-text">Rechazados</p>
                            <div class="progress">
                                <div
                                    class="progress-bar pb-rechazados"
                                    role="progressbar"
                                    [style.width]="porcRechazados + '%'"
                                    [attr.aria-valuenow]="porcRechazados"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ porcRechazados | number : "1.0-0" }}%
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- card-body -->
                </div>
            </div>
        </div>
    </div>
</div>
